import { Menu } from '@base-ui-components/react/menu'
import { cn } from '../../utils/cn'

export function MenuPopup({ className, ...props }: MenuPopup.Props) {
  return (
    <Menu.Popup
      className={cn(
        'rounded-lg bg-[canvas] py-1 shadow-sm outline outline-gray-200',
        'origin-(--transform-origin) transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
        className
      )}
      {...props}
    />
  )
}

export namespace MenuPopup {
  export interface Props extends Menu.Popup.Props {}
}
